import { useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'

export const ROWS_PER_BATCH = 20

/**
 * Renders a long list in batches: the first `batchSize` items, then the
 * next batch whenever the element given `endRef` scrolls within 400px of
 * the viewport. Keeps big member lists from mounting every row (and avatar
 * image) at once.
 */
const useBatchedRows = <T>(items: T[], batchSize = ROWS_PER_BATCH) => {
  const [shownCount, setShownCount] = useState(batchSize)
  const shown = items.slice(0, shownCount)
  const isComplete = shown.length === items.length

  const { ref: endRef, inView: endIsInView } = useInView({
    rootMargin: '400px',
  })

  useEffect(() => {
    if (endIsInView && !isComplete) setShownCount((count) => count + batchSize)
    // Re-checks after every batch, so it keeps going while the end is visible
  }, [endIsInView, isComplete, shownCount, batchSize])

  return { shown, isComplete, endRef }
}

export default useBatchedRows
